<template>
    <div class="report__page">
        <h2>Report Details</h2>
        <ReportDetailsSelector 
            :details="customDetails"
            :is-compact="false"
        />
        <!-- MANAGEMENT ACTIVITY LOG -->
    </div>
</template>

<script>
import ReportDetailsSelector from './ReportDetailsSelector.vue';

export default {
    components: {
        ReportDetailsSelector
    },

    data() {
        return {
            customDetails: [
                { value: 'timestamp', label: 'Date / Time' },
                { value: 'user', label: 'User' },
                { value: 'activity', label: 'Activity' },
                { value: 'site', label: 'Site' }
            ]
        }
    }
}
</script>

<style lang="scss" scoped>
.report__page {
    height: 100%;
    padding: 0.5rem;

    h2 {
        padding-left: 1rem;
        margin: 0;
    }
}
</style>